<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-subscription-type-wizard [index]="index" [isEditMode]="true" [uuid]="uuid" > </well-subscription-type-wizard>


